import CssBaseline from '@mui/material/CssBaseline';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React from 'react';

import { deepmerge } from '@mui/utils';
import { getSelectedTheme } from '../../themeConfig';
import { useHomeData } from '../LoadHomeData/HomeDataProvider';

const fontFamily = '"Raleway", "Roboto", "Helvetica", "Arial", sans-serif;';

const defaultTheme = {
    typography: {
        fontFamily,
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        caption: { fontSize: '0.8rem' },
    },
};
interface ThemeProps {
    children: React.ReactNode;
}

export const Theme: React.FC<ThemeProps> = ({ children }) => {
    const { homepageData } = useHomeData();
    const environment = homepageData?.environment;
    const selectedTheme = getSelectedTheme(environment);
    const theme = createTheme(deepmerge(defaultTheme, selectedTheme));

    if (!environment) {
        return <LinearProgress />;
    }

    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    );
};
